import { render, staticRenderFns } from "./ObservacionesResultadoC3DialogComponent.vue?vue&type=template&id=6556d632&scoped=true"
import script from "./ObservacionesResultadoC3DialogComponent.vue?vue&type=script&lang=js"
export * from "./ObservacionesResultadoC3DialogComponent.vue?vue&type=script&lang=js"
import style0 from "./ObservacionesResultadoC3DialogComponent.vue?vue&type=style&index=0&id=6556d632&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6556d632",
  null
  
)

export default component.exports